// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffb6de19","732":"3c2ab769","977":"9941dd55"}[chunkId] + ".chunk.js";
};